@import "../fonts.css";
.card {
	border-radius: 10px;
	border: 1px solid #e3e3e3;
	padding: 12px 15px;
	background: #fff;
	display: flex;
	gap: 10px;
	flex-direction: column;
}

.cardUseHeader {
	padding: 0;
	padding-bottom: 0.75rem;
}

.cardSettings {
	min-width: 0;
	/* overflow: hidden; */
	gap: 0;
	padding: 0;
	border: 1px solid #e3e3e3;
	border-radius: 8px;
	box-shadow: none;
}

.cardSettings.cardUseHeader {
	padding-bottom: 0;
}

.cardTitle {
	display: flex;
	gap: 8px;
	align-items: center;
}

.cardTitleIcon {
	height: 24px;
	width: 24px;
	min-height: 24px;
	min-width: 24px;
	border-radius: 50%;
	background-color: #d6e5e9;
	display: flex;
	place-content: center;
	align-items: center;
}

.cardTitleHeader {
	display: flex;
	gap: 8px;
	align-items: center;
	height: 35px;
	width: 100%;
}

.cardTitleIconHeader {
	height: 24px;
	width: 24px;
	min-height: 24px;
	min-width: 24px;
	color: #42296e;
	display: flex;
	place-content: center;
	align-items: center;
}

.cardTitleText {
	font-weight: 600;
	color: #42296e;
	font-family: inherit;
	text-align: start;
}

.cardTitleHeader .cardTitleText {
	flex: 1;
	font-size: 15px;
	font-weight: 600;
	color: #2b2f32;
}

div.cardTitleRightContent {
	display: flex;
	justify-content: space-between;
	width: 100%;
	align-items: center;
}

.cardDescription:global(.MuiTypography-root) {
	font-size: 14px;
	font-weight: 400;
	color: #525252;
	line-height: 1.6;
}

.cardTitleIcon svg,
.cardTitleIconHeader svg {
	width: 24px;
	height: 24px;
}

.cardTitleIcon svg path {
	fill: #0b6f85;
}

.cardTitleIcon.strokeColor svg path {
	stroke: #0b6f85;
	fill: none;
}

.cardTitleIconHeader.strokeColor svg path {
	stroke: #42296e;
	fill: none;
}

.cardHeader {
	padding: 8px 15px;
	background: #fafafa;
	border-radius: 8px 8px 0 0;
	border-bottom: 1px solid #e3e3e3;
}

.cardSettings .cardHeader {
	display: flex;
	align-items: center;
	min-height: 52px;
	box-sizing: border-box;
}

.cardSettings .bodyWrapperUseHeader {
	min-width: 0;
	padding: 16px;
}

.cardSettings .bodyWrapperUseHeader:has(.proctoring-option-tab-header) {
	padding-top: 0;
}

.rightContentWrapper {
	display: flex;
	justify-content: space-between;
}

.cardBodyWrapper {
	padding: 0;
	height: 100%;
}

.bodyWrapperUseHeader {
	padding: 0 15px;
}
